// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1A9oq","label":"CategoryService_label__2e5Y-","location":"CategoryService_location__3lXfD"};